@if(mostrarBanner) {
<div class="cookie-banner" @fadeInOut>
   <div>
    <p class="cookie-text">Utilizamos cookies essenciais e tecnologias semelhantes de acordo com a nossa
      <span class="link-download" tabindex="0" (click)="abrirPoliticasPrivacidade()" (keyup.enter)="abrirPoliticasPrivacidade()">Política de Privacidade</span>&nbsp;e, ao continuar navegando, você concorda com essas condições.</p>
   </div>
   <button class="accept-btn" (click)="adicionarCookie()">Ok, entendi</button>
</div>
}